import { render, staticRenderFns } from "./govmglogin.vue?vue&type=template&id=5973a4ec&"
import script from "./govmglogin.vue?vue&type=script&lang=js&"
export * from "./govmglogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports